<HiddenFromSSR>
  <FreeTextLayout>
    <div class="not-logged-in-home">
      <div class="logo-wrap">
        <img class="not-logged-in-home-logo" src="/icons/icon-source.svg" alt="" />
      </div>
      <h1>{$messages["appName"]}</h1>
      <div class="not-logged-in-home-description">
        {@html $messages["homeDescription"]}
      </div>
      {#if singleInstance}
        <button class="button primary not-logged-in-home-button" on:click="logIn()">{$messages["logIn"]}</button>
      {:else}
        <a class="button primary not-logged-in-home-button" rel="prefetch" href="/settings/instances/add">{$messages["logIn"]}</a>
      {/if}
      <!-- Language picker for logged-out users (they can't reach Settings). Pushed to the bottom
           of the container via margin-top:auto; switches the UI language instantly (store.locale). -->
      <div class="login-language-picker">
        <Select id="login-language"
                options={languageOptions}
                defaultValue={$locale}
                label="{$messages["language"]}"
                on:change="onLanguageChange(event)" />
      </div>
    </div>
  </FreeTextLayout>
</HiddenFromSSR>
<style>
  .not-logged-in-home {
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  /* Language picker pinned 1cm above the bottom edge of the card (<main>, which is position:relative
     with min-height:70vh — see global.scss). position:absolute takes it out of flow, so it sits in
     the card's empty lower area WITHOUT stretching the card (no mobile scroll) and WITHOUT touching
     the page footer (which is a separate element below <main>, not inside it). */
  .login-language-picker {
    position: absolute;
    left: 50%;
    bottom: 1cm;
    transform: translateX(-50%);
  }

  .logo-wrap {
    position: relative;
    display: inline-flex;
    margin: 24px 0 28px;
  }

  /* subtle glow/shimmer behind the logo */
  .logo-wrap::before {
    content: '';
    position: absolute;
    inset: -45%;
    background: radial-gradient(circle, rgba(108, 99, 255, 0.45) 0%, rgba(108, 99, 255, 0) 70%);
    filter: blur(12px);
    z-index: 0; /* above the panel background, behind the logo (z-index:-1 hid it) */
    pointer-events: none;
  }

  .not-logged-in-home-logo {
    position: relative;
    z-index: 1;
    width: 104px;
    height: 104px;
    border-radius: 5px;
    display: block;
  }

  .not-logged-in-home h1 {
    color: var(--main-text-color);
    font-size: 3em;
    font-weight: 700;
    margin: 0 0 4px;
  }

  .not-logged-in-home-description {
    color: var(--deemphasized-text-color);
    font-size: 1.1em;
  }

  .not-logged-in-home-description :global(p) {
    margin: 8px 0 20px;
  }

  .not-logged-in-home-button {
    margin-top: 8px;
  }

  @media (max-width: 767px) {
    .not-logged-in-home h1 {
      font-size: 2.7em;
    }
  }

  @media (max-width: 240px) {
    .not-logged-in-home h1 {
      font-size: 2.5em;
    }
  }
</style>
<script>
  import FreeTextLayout from './FreeTextLayout.html'
  import HiddenFromSSR from './HiddenFromSSR.html'
  import Select from './Select.html'
  import { logInToInstance } from '../_actions/addInstance.js'
  import { getSingleInstance } from '../_utils/getSingleInstance.js'
  import { AVAILABLE_LOCALES } from '../_intl/locales.js'

  export default {
    components: {
      FreeTextLayout,
      HiddenFromSSR,
      Select
    },
    data: () => {
      return {
        singleInstance: getSingleInstance(),
        // Static list for the language picker; autonyms aren't translated.
        languageOptions: AVAILABLE_LOCALES.map(l => ({ value: l.code, label: l.name }))
      }
    },
    methods: {
      logIn () {
        this.store.set({ instanceNameInSearch: getSingleInstance() })
        logInToInstance()
      },
      onLanguageChange (event) {
        // Same as the Settings picker: setting locale re-renders $messages instantly (no reload).
        // this.store is inherited from the root _layout (this component doesn't bind its own store).
        this.store.set({ locale: event.target.value })
        this.store.save()
      }
    }
  }
</script>
